import { createContext } from 'react';

export const FieldTypeContext = createContext();